import React from 'react';
import { Paper, CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import Header from '../Header';
import Footer from '../Footer';
import { theme, useStyle } from './styles';
import { Box, styled } from '@mui/system';

const Container = styled('div')(({ theme }) => ({
  margin: '10px',
  [theme.breakpoints.down('sm')]: {
    margin: '16px',
  },
  '& .breadcrumb': {
    marginBottom: '30px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '16px',
    },
  },
}));

export default function MaterialLayout(props) {
  const { children } = props;
  const classes = useStyle();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* <Header /> */}
      {/* <Container> */}
      <div className={classes.root}>
        <Paper className={classes.paper}>{children}</Paper>
      </div>
      {/* </Container> */}
      <Footer />
    </ThemeProvider>
  );
}
